import { render } from "./Index.vue?vue&type=template&id=6524c0b3&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6524c0b3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6524c0b3"

export default script